// components/extras/ExtraInfoCard.js
// Card per informazioni base dell'extra (titolo, tipo, totale)

import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { formatCurrency } from '../../lib/utils';

const ExtraInfoCard = ({
  formData,
  setFormData,
  grandTotal,
  isAdminOrAdministration,
  isContractEffective,
  onReclassify
}) => {
  return (
    <Card className="card-abitalo">
      <CardContent className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <Label htmlFor="title">
              Titolo Extra <span className="text-red-500">*</span>
            </Label>
            <Input
              id="title"
              value={formData.title}
              onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
              placeholder="Es: Lavori aggiuntivi bagno"
              className={!formData.title ? 'border-red-300 focus:border-red-500' : ''}
              data-testid="extra-title-input"
            />
          </div>
          <div>
            <Label htmlFor="extra_type">Tipo</Label>
            {isAdminOrAdministration && isContractEffective ? (
              <div className="flex items-center gap-2 mt-0">
                <div className="h-10 px-3 py-2 border border-[#DCDCDC] rounded-md bg-gray-50 text-[#3C3C3C] flex items-center flex-1">
                  {formData.extra_type === 'fornitura' ? 'Fornitura' : 'Lavoro'}
                </div>
                <button
                  type="button"
                  onClick={onReclassify}
                  className="text-xs font-medium text-[#FF7819] hover:underline whitespace-nowrap"
                  data-testid="reclassify-open-btn"
                >
                  Correggi classificazione
                </button>
              </div>
            ) : isAdminOrAdministration ? (
              <Select
                value={formData.extra_type}
                onValueChange={(value) => setFormData(prev => ({ ...prev, extra_type: value }))}
              >
                <SelectTrigger data-testid="extra-type-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="lavoro">Lavoro</SelectItem>
                  <SelectItem value="fornitura">Fornitura</SelectItem>
                </SelectContent>
              </Select>
            ) : (
              <div className="h-10 px-3 py-2 border border-[#DCDCDC] rounded-md bg-gray-50 text-[#3C3C3C] flex items-center">
                {formData.extra_type === 'fornitura' ? 'Fornitura' : 'Lavoro'}
              </div>
            )}
          </div>
          <div>
            <Label>Totale Extra</Label>
            <div className="text-2xl font-bold text-[#FF7819] mt-1" data-testid="extra-grand-total">
              {formatCurrency(grandTotal)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ExtraInfoCard;
